import { useLayoutEffect, useRef } from 'react';

/** A ref holding the latest `value`, for stable callbacks (runtime adapters, async handlers) that must read
 *  current props or state without being recreated when they change. Updated after each commit. */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
